import { Component, Inject, Input, OnChanges, SimpleChanges } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { AppComponent } from "../app/app.component";
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { ViewChild } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";
declare var google: any;

@Component({
    selector: "otherdriver",
    template: require('./otherdriver.component.html'),
    styles: [require('./otherdriver.component.css')]
})
export class OtherdriverComponent implements OnChanges {

    report: CollisionReport;
    otherDriver: OtherDriver = <OtherDriver>{};
    customerList: Array<String> = [];
    cityList: Array<String> = [];
    provinceList: Array<String> = [];
    searchtext: string = "";
    modelList: Array<String> = []
    colorList: Array<String> = [];
    isDriverOwner: boolean = true;

    preventCityClear: boolean;
    preventProvinceClear: boolean;
    preventCarMakeModelClear: boolean;
    preventColorClear: boolean;
    preventInsuranceClear: boolean;

    constructor(private appcomponent: AppComponent, private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: "",
        private router: Router, private spinnerService: Ng4LoadingSpinnerService) {
        this.report = appcomponent.getReport();

        this.preventCityClear = false;
        this.preventProvinceClear = false;
        this.preventCarMakeModelClear = false;
        this.preventColorClear = false;
        this.preventInsuranceClear = false;

        if (this.report.CollisionReportUniqueId == null) {
            this.reportGetSync();
            this.router.navigate([this.router.url])
        }
        if (this.report.IsNew) {
            this.router.navigate(["home"]);
        }

        if (this.report.OtherDrivers == null || this.report.OtherDrivers.length == 0)
            this.report.OtherDrivers = [];

        this.otherDriver.OtherDriverDriversVehicle = "YES";

        this.otherDriver = <OtherDriver>{};
        document.body.scrollTop = 0;

        var collisionInvolvedDropdown = <HTMLInputElement>document.getElementById("SequenceOfEvents1");
        if (collisionInvolvedDropdown != null) {
            if (this.report != null && this.report.EntityType == "PEDESTRIAN") {
                collisionInvolvedDropdown.value = "3";
            }
            else if (this.report != null && this.report.EntityType == "CYCLIST") {
                collisionInvolvedDropdown.value = "4";
            }
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (typeof changes['report'] !== "undefined") {
            // retrieve the report variable change info
            var change = changes['report'];
            // only perform the task if the value has been changed
            if (!change.isFirstChange()) {
                // execute the Http request and retrieve the result
                //DO SOmething
                alert('changed');
            }
        }
        else
            console.log("Undefined");
    }

    onBack(): void {
        if (this.report.EntityType != null && (this.report.EntityType == "PEDESTRIAN" || this.report.EntityType == "CYCLIST")) {
            if (this.report.WereYouInjured) {
                this.BackAndPost("injury");
            }
            else {
                this.BackAndPost("prequalification");
            }
        }
        else {
            this.BackAndPost("owner");
        }
    }

    private BackAndPost(page: string): void {
        this.report.CurrentPage = page;
        //  this.appcomponent.setReport(this.report);
        this.router.navigate([page]);
    }

    onSubmit(): void {
        //   alert('SUCCESS!! :-)\n\n' + JSON.""ify(this.report));
        //this.onAddDriver();

        if (this.report.EntityType != null && (this.report.EntityType == "PEDESTRIAN" || this.report.EntityType == "CYCLIST")) {
            if (this.report.WereYouInjured) {
                this.ValidateAndPost("witness");
            }
            else {
                this.ValidateAndPost("witness");
            }
        }
        else {
            this.ValidateAndPost("witness");
        }
    }

    onHasOtherDriver(status: boolean): void {
        this.report.HasOtherDriver = status;
    }

    onAddDriver(): void {
        if (typeof this.otherDriver.OtherDriverLastName == 'undefined') {
            alert("Last name cannot be empty.");
            return;
        }

        if (this.otherDriver.OtherDriverPhone != null && this.otherDriver.OtherDriverPhone != '' &&
            (this.otherDriver.OtherDriverPhone.length != 14 ||
                this.otherDriver.OtherDriverPhone.indexOf('(') == -1 ||
                this.otherDriver.OtherDriverPhone.indexOf(')') == -1 ||
                this.otherDriver.OtherDriverPhone.indexOf('-') == -1
            )) {
            alert("Phone number not in the correct format.");
            return;
        }

        if (this.Isvalid()) {
            this.otherDriver.OtherDriverIndex = this.report.OtherDrivers.length + 1;
            this.otherDriver.CollisionReportId = this.appcomponent.getReport().CollisionReportId;
            this.otherDriver.OtherDriverId = Math.floor(Math.random() * 100000);
            this.report.OtherDrivers.push(this.otherDriver);
            this.otherDriver = <OtherDriver>{};
            this.otherDriver.IsOtherDriverNameUnknown = false;
            this.otherDriver.IsOtherDriverPlateUnknown = false;
            window.scrollTo(0, 0);

            // alert('Driver Added');
            // this.onSubmit();
            this.onHasOtherDriver(false);
        }
    }

    onCancelAddDriver(): void {

        this.otherDriver = <OtherDriver>{};
        this.otherDriver.IsOtherDriverNameUnknown = false;
        this.otherDriver.IsOtherDriverPlateUnknown = false;
                    
        this.onHasOtherDriver(false);
    }

    onSelectDriver(driver: OtherDriver): void {
        this.otherDriver = <OtherDriver>{};
        this.otherDriver = driver;
    }

    onDeleteDriver(driver: OtherDriver): void {
        if (confirm("Do you really want to delete this driver?")) {
            for (var i = 0; i < this.report.OtherDrivers.length; i++) {
                if (this.report.OtherDrivers[i].OtherDriverIndex == driver.OtherDriverIndex) {
                    if (this.report.OtherDrivers[i].OtherDriverId > 0) {
                        this.report.OtherDrivers.splice(i, 1);      
                    }
                    else
                        this.report.OtherDrivers.splice(i, 1);
                    break;
                }
            }
        }
    }

    onEditDriver(): void {
        if (this.Isvalid()) {
            for (var i = 0; i < this.report.OtherDrivers.length; i++) {
                if (this.report.OtherDrivers[i].OtherDriverIndex == this.otherDriver.OtherDriverIndex) {
                    var url = this.baseUrl + "api/report/UpdateOtherDriver";
                    this.spinnerService.show();
                    this.http
                        .post(url, this.otherDriver)
                        .subscribe(res => {
                            var v = res as OtherDriver;
                            this.otherDriver = v;
                        }, error => console.log(error), () => this.spinnerService.hide());
                    this.report.OtherDrivers[i] = this.otherDriver;
                    break;
                }
            }
            this.otherDriver = <OtherDriver>{};
            window.scrollTo(0, 0);
        }
    }

    onCancelDriver(): void {
        this.otherDriver = <OtherDriver>{};
        this.otherDriver.IsOtherDriverNameUnknown = false;
        this.otherDriver.IsOtherDriverPlateUnknown = false;
    }

    //private ValidateAndPost(page: string) {
    //    if (this.IsPageValid()) {
    //        this.report.IsOtherDriverPageValid = true;
    //        // this.report.OtherDrivers.push(this.otherDriver);
    //        this.report.CurrentPage = page;
    //        if (this.appcomponent.setDataReport(this.report)) {
    //            this.router.navigate([page]);
    //        }
    //        else {
    //            alert("Error occurred while saving Report data.");
    //        }
    //    }
    //}

    private ValidateAndPost(page: string) {
        if (this.IsPageValid()) {
            this.report.IsOtherDriverPageValid = true;
            this.report.CurrentPage = page;
            this.appcomponent.setReport(this.report);
            this.router.navigate(["witness"]);
        }
    }

    onPhoneInput(): void {
        var phone = this.otherDriver.OtherDriverPhone.replace(/[^0-9]/g, "");
        var v = phone.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
        this.otherDriver.OtherDriverPhone = v;
    }

    onPlateInput(): void {
        var v = this.otherDriver.OtherDriverPlateNUM.replace(/\s/, '').replace('_', '').replace(/\W/g, '');
        this.otherDriver.OtherDriverPlateNUM = v
    }

    private IsPageValid(): boolean {
        if (this.report.HasOtherDriver == null) {
            alert("Please specify if there was other driver");
            return false;
        }

        if (this.report.HasOtherDriver != null && this.report.HasOtherDriver) {
            if (this.report.OtherDrivers == null || this.report.OtherDrivers.length == 0) {
                alert("Please add other driver information before proceeding to next page");
                return false;
            }
        }

        return true;
    }

    private Isvalid(): boolean {
        if (this.otherDriver.IsOtherDriverNameUnknown == null || !this.otherDriver.IsOtherDriverNameUnknown) {
            if (this.otherDriver.OtherDriverLastName == null || this.otherDriver.OtherDriverFirstName == null) {
                return false;
            }
        }

        if (this.otherDriver.IsOtherDriverPlateUnknown == null || !this.otherDriver.IsOtherDriverPlateUnknown) {
            if (this.otherDriver.OtherDriverPlateNUM == null || this.otherDriver.OtherDriverPlateNUM.trim().length == 0) {
                return false;
            }
        }

        if (this.otherDriver.OtherDriverOtherVehicleDoing == null || this.otherDriver.OtherDriverDirectionTheOtherVehicle == null || this.otherDriver.OtherDriverYourVehicleHitOrHitByEvent1 == null) { return false; }
        return true;
    }

    onSetUnknownName(value: boolean): void {
        if (this.otherDriver.IsOtherDriverNameUnknown) {
            this.otherDriver.OtherDriverFirstName = "UNKNOWN";
            this.otherDriver.OtherDriverLastName = "UNKNOWN";
        }
        else {
            this.otherDriver.OtherDriverFirstName = "";
            this.otherDriver.OtherDriverLastName = "";
        }
    }

    onSetUnknownPlate(value: boolean): void {
        if (this.otherDriver.IsOtherDriverPlateUnknown) {
            this.otherDriver.OtherDriverPlateNUM = "UNKNOWN";
        }
        else {
            this.otherDriver.OtherDriverPlateNUM = "";
        }
    }

    searchInsurance = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(200),
            distinctUntilChanged(),
            map(term => term.length < 2 ? []
                : this.getInsuranceData(term))
        );

    getInsuranceData(term: string): Array<String> {
        // states.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10)
        var url = this.baseUrl + "api/report/Customer/" + term;
        var data: any;

        this.http
            .get(url)
            .subscribe(res => {
                data = res as string[];
                for (let i = 0; i < data.length; i++) {
                    this.customerList.push(data[i]);
                }
            }, error => console.log(error));

        if (data == null) {
            this.customerList.push("Not Found");
        }

        return Array.from(new Set(this.customerList)).filter(item =>
            item.toLowerCase().includes(term.toLowerCase()));
    }

    searchCity = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(200),
            distinctUntilChanged(),
            map(term => term.length < 2 ? []
                : this.searchCityData(term))
        );

    searchCityData(term: string): Array<String> {
        // states.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10)
        var url = this.baseUrl + "api/report/City/" + term;
        var data: any;

        this.http
            .get(url)
            .subscribe(res => {
                data = res as string[];
                for (let i = 0; i < data.length; i++) {
                    this.cityList.push(data[i]);
                }
            }, error => console.log(error));

        if (data == null) {
            this.cityList.push("Not Found");
        }

        return Array.from(new Set(this.cityList)).filter(item =>
            item.toLowerCase().includes(term.toLowerCase()));
    }

    searchPlateProvince = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(200),
            distinctUntilChanged(),
            map(term => term.length < 2 ? []
                : this.searchPlateProvinceData(term))
        );

    searchPlateProvinceData(term: string): Array<String> {
        // states.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10)
        var url = this.baseUrl + "api/report/Province/" + term;
        var data: any;
        this.http
            .get(url)
            .subscribe(res => {
                data = res as string[];
                for (let i = 0; i < data.length; i++) {
                    this.provinceList.push(data[i]);
                }
            }, error => console.log(error));

        if (data == null) {
            this.provinceList.push("Not Found");
        }

        return Array.from(new Set(this.provinceList)).filter(item =>
            item.toLowerCase().includes(term.toLowerCase()));
    }

    findChoicesInsurance(customerList: Array<String>) {
        return (searchText: any) => {
            var url = this.baseUrl + "api/report/City/" + this.searchtext;
            var data: any;

            this.http
                .get(url)
                .subscribe(res => {
                    data = res as string[];
                    for (let i = 0; i < data.length; i++) {
                        customerList.push(data[i]);
                    }
                }, error => console.log(error));

            if (data == null) {
                customerList.push("Not Found");
            }

            return Array.from(new Set(customerList)).filter(item =>
                item.toLowerCase().includes(searchText.toLowerCase()));
        };
    }

    getChoiceLabelInsurance(choice: string) {
        return choice;
    }

    findChoicesCity(cityList: Array<String>) {
        return (searchText: any) => {
            var url = this.baseUrl + "api/report/City/" + searchText;
            var data: any;

            this.http
                .get(url)
                .subscribe(res => {
                    data = res as string[];
                    for (let i = 0; i < data.length; i++) {
                        cityList.push(data[i]);
                    }
                }, error => console.log(error));

            if (data == null) {
                cityList.push("Not Found");
            }

            return Array.from(new Set(cityList)).filter(item =>
                item.toLowerCase().includes(searchText.toLowerCase()));
        };
    }

    getChoiceLabelCity(choice: string) {
        return choice;
    }

    setAutocomplete(): void {
        var autoCompleteOptions = {
            types: [],
            componentRestrictions: { country: 'ca' }
        };

        var self = this;
        var autoCompleteElement = document.getElementById('Address');
        var searchBox = new google.maps.places.Autocomplete(autoCompleteElement, autoCompleteOptions);
        //searchBox.bindTo('bounds', map);

        google.maps.event.addListener(searchBox, 'place_changed', function () {
            var place = searchBox.getPlace();
            if (!place.geometry) {
                //NOT SURE
            }
            else {
                var address: string = place.formatted_address;
                var array = address.split(",");
                self.report.Address = array[0];
                var provPostal = array[2].trim();

                self.report.City = array[1].trim() + ", " + provPostal.substring(0, provPostal.indexOf(' '));
                self.report.PostalCode = provPostal.substring(provPostal.indexOf(' ') + 1);
            }
        });
    }

    searchCar = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(200),
            distinctUntilChanged(),
            map(term => term.length < 2 ? []
                : this.getCarData(term))
        );

    getCarData(term: string): Array<String> {
        // states.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10)
        var url = this.baseUrl + "api/report/Car/" + term;
        var data: any;

        this.http
            .get(url)
            .subscribe(res => {
                data = res as string[];
                for (let i = 0; i < data.length; i++) {
                    this.modelList.push(data[i]);
                }
            }, error => console.log(error));

        if (data == null) {
            this.modelList.push("Not Found");
        }

        return Array.from(new Set(this.modelList)).filter(item =>
            item.toLowerCase().includes(term.toLowerCase()));
    }

    searchColor = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(200),
            distinctUntilChanged(),
            map(term => term.length < 2 ? []
                : this.getColorData(term))
        );

    getColorData(term: string): Array<String> {
        // states.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10)
        var url = this.baseUrl + "api/report/Color/" + term;
        var data: any;

        this.http
            .get(url)
            .subscribe(res => {
                data = res as string[];
                for (let i = 0; i < data.length; i++) {
                    this.colorList.push(data[i]);
                }
            }, error => console.log(error));

        if (data == null) {
            this.colorList.push("Not Found");
        }

        return Array.from(new Set(this.colorList)).filter(item =>
            item.toLowerCase().includes(term.toLowerCase()));
    }

    onOtherDriverDriversVehicle(choice: string) {
        if (choice == "YES") {
            this.otherDriver.OtherDriverDriversVehicle = "YES";
            this.isDriverOwner = true;
        }
        else if (choice == "NO") {
            this.otherDriver.OtherDriverDriversVehicle = "NO";
            this.isDriverOwner = false;
        }
        else {
            this.otherDriver.OtherDriverDriversVehicle = "";
            this.isDriverOwner = true;
        }
    }

    numberOnly(event: any): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    }

    
    //City autocomplete fixes
    selectedCity(event: any) {
        this.preventCityClear = true;
        this.otherDriver.OtherDriverCity = event.item;
    }

    clearCity() {
        this.otherDriver.OtherDriverCity = "";
    }

    blurCity() {
        if (this.otherDriver.OtherDriverCity != null && this.otherDriver.OtherDriverCity != '' && !this.preventCityClear) {
            this.clearCity();
        }
        else if (this.otherDriver.OtherDriverCity == null || this.otherDriver.OtherDriverCity == '') {
            setTimeout(() => {
                if (document.getElementById("OtherDriverCity") != null)
                    (<HTMLInputElement>document.getElementById("OtherDriverCity")).value = '';
            }, 100);
        }
        else {
            this.preventCityClear = false;
        }
    }

    //Province autocomplete fixes
    selectedProvince(event: any) {
        this.preventProvinceClear = true;
        this.otherDriver.OtherDriverLicenseProvince = event.item;
    }

    clearProvince() {
        this.otherDriver.OtherDriverLicenseProvince = "";
    }

    blurProvince() {
        if (this.otherDriver.OtherDriverLicenseProvince != null && this.otherDriver.OtherDriverLicenseProvince != '' && !this.preventProvinceClear) {
            this.clearProvince();
        }
        else if (this.otherDriver.OtherDriverLicenseProvince == null || this.otherDriver.OtherDriverLicenseProvince == '') {
            setTimeout(() => {
                if (document.getElementById("OtherDriverLicenseProvince") != null)
                    (<HTMLInputElement>document.getElementById("OtherDriverLicenseProvince")).value = '';
            }, 100);
        }
        else {
            this.preventProvinceClear = false;
        }
    }


    //CarMakeModel autocomplete fixes
    selectedCarMakeModel(event: any) {
        this.preventCarMakeModelClear = true;
        this.otherDriver.OtherDriverVehicleModel = event.item;
    }

    clearCarMakeModel() {
        this.otherDriver.OtherDriverVehicleModel = "";
    }

    blurCarMakeModel() {
        if (this.otherDriver.OtherDriverVehicleModel != null && this.otherDriver.OtherDriverVehicleModel != '' && !this.preventCarMakeModelClear) {
            this.clearCarMakeModel();
        }
        else if (this.otherDriver.OtherDriverVehicleModel == null || this.otherDriver.OtherDriverVehicleModel == '') {
            setTimeout(() => {
                if (document.getElementById("OtherDriverVehicleModel") != null)
                    (<HTMLInputElement>document.getElementById("OtherDriverVehicleModel")).value = '';
            }, 100);
        }
        else {
            this.preventCarMakeModelClear = false;
        }
    }

   
    //Color autocomplete fixes
    selectedColor(event: any) {
        this.preventColorClear = true;
        this.otherDriver.OtherDriverVehicleColor = event.item;
    }

    clearColor() {
        this.otherDriver.OtherDriverVehicleColor = "";
    }

    blurColor() {
        if (this.otherDriver.OtherDriverVehicleColor != null && this.otherDriver.OtherDriverVehicleColor != '' && !this.preventColorClear) {
            this.clearColor();
        }
        else if (this.otherDriver.OtherDriverVehicleColor == null || this.otherDriver.OtherDriverVehicleColor == '') {
            setTimeout(() => {
                if (document.getElementById("OtherDriverVehicleColor") != null)
                    (<HTMLInputElement>document.getElementById("OtherDriverVehicleColor")).value = '';
            }, 100);
        }
        else {
            this.preventColorClear = false;
        }
    }

    //Insurance autocomplete fixes
    selectedDriverInsuranceCompany(event: any) {
        this.preventInsuranceClear = true;
        this.otherDriver.OtherDriverInsuranceCompany = event.item;
    }

    clearDriverInsuranceCompany() {
        this.otherDriver.OtherDriverInsuranceCompany = "";
    }

    blurDriverInsuranceCompany() {
        if (this.otherDriver.OtherDriverInsuranceCompany != null && this.otherDriver.OtherDriverInsuranceCompany != '' && !this.preventInsuranceClear) {
            this.clearDriverInsuranceCompany();
        }
        else if (this.otherDriver.OtherDriverInsuranceCompany == null || this.otherDriver.OtherDriverInsuranceCompany == '') {
            setTimeout(() => {
                if (document.getElementById("OtherDriverInsuranceCompany") != null)
                    (<HTMLInputElement>document.getElementById("OtherDriverInsuranceCompany")).value = '';
            }, 100);
        }
        else {
            this.preventInsuranceClear = false;
        }
    }


    reportGetSync(): void {
        var url = this.baseUrl + "api/report";
        this.http
            .get(url)
            .toPromise().then(result => {
                var v = result as CollisionReport;
                this.report = v;
            });
    }
}